import styled from 'styled-components'

export const FooterContainer = styled.div`
    background: black;
    text-align: center;
    padding-top: 10px;
    padding-bottom: 10px;

`

export const FooterTitle = styled.p`
    color: white;
    font-size: 1.5rem;
`

export const FooterDesc = styled.p`
    color: white;
    font-size: 1rem;
`